import { get_AppScopes4bqeg21n0qw as get_AppScope } from './AppScope.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  _ReactiveState___init__impl__fvdp9b2eqyidpf491cp as _ReactiveState___init__impl__fvdp9b,
  Companion_getInstance1a6q7ejsqzzhs as Companion_getInstance,
} from './ReactiveState.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { BaseReactive302n39o7i5yop as BaseReactive } from './abstracts.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function reactiveProcess(scope, emitter) {
  scope = scope === VOID ? get_AppScope() : scope;
  return reactiveProcess$1().faq(scope, emitter);
}
var EmitterClass;
function Emitter() {
  if (EmitterClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Emitter', VOID, VOID, [CoroutineScope()]);
    EmitterClass = $;
  }
  return EmitterClass;
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp = $this.haq_1(new (reactiveProcess$1$activate$2$1())($this$launch, $this.iaq_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var reactiveProcess$1$activate$2$1Class;
function reactiveProcess$1$activate$2$1() {
  if (reactiveProcess$1$activate$2$1Class === VOID) {
    class $ {
      constructor($this_launch, this$0) {
        this.kaq_1 = this$0;
        this.jaq_1 = $this_launch;
      }
      gaq(value) {
        this.kaq_1.rah(_ReactiveState___init__impl__fvdp9b(value));
      }
      ga2() {
        return this.jaq_1.ga2();
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Emitter(), CoroutineScope()]);
    reactiveProcess$1$activate$2$1Class = $;
  }
  return reactiveProcess$1$activate$2$1Class;
}
var reactiveProcess$o$activate$slambdaClass;
function reactiveProcess$o$activate$slambda() {
  if (reactiveProcess$o$activate$slambdaClass === VOID) {
    class $ {
      constructor($emitter, this$0) {
        this.haq_1 = $emitter;
        this.iaq_1 = this$0;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    reactiveProcess$o$activate$slambdaClass = $;
  }
  return reactiveProcess$o$activate$slambdaClass;
}
function reactiveProcess$o$activate$slambda_0($emitter, this$0) {
  var i = new (reactiveProcess$o$activate$slambda())($emitter, this$0);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var reactiveProcess$1Class;
function reactiveProcess$1() {
  if (reactiveProcess$1Class === VOID) {
    class $ extends BaseReactive() {
      static faq($scope, $emitter, $box) {
        if ($box === VOID)
          $box = {};
        $box.daq_1 = $scope;
        $box.eaq_1 = $emitter;
        var $this = this.ial(VOID, $box);
        $this.caq_1 = null;
        return $this;
      }
      kal() {
        this.rah(Companion_getInstance().oah_1);
        var tmp = this;
        tmp.caq_1 = launch(this.daq_1, VOID, VOID, reactiveProcess$o$activate$slambda_0(this.eaq_1, this));
      }
      lal() {
        var tmp0_safe_receiver = this.caq_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.oa3();
        }
        this.caq_1 = null;
      }
    }
    initMetadataForClass($);
    reactiveProcess$1Class = $;
  }
  return reactiveProcess$1Class;
}
//region block: exports
export {
  Emitter as Emitter3oauzcbmv9irf,
  reactiveProcess as reactiveProcess2z4nh4eb606pm,
};
//endregion

//# sourceMappingURL=processes.mjs.map
